
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.346 10.484a2.872 2.872 0 00.583-1.735c0-1.002-.56-1.95-1.462-2.48a1.51 1.51 0 00-.766-.207h-5.353l.134-2.743a2.39 2.39 0 00-.658-1.773A2.38 2.38 0 009.085.801c-1.16 0-2.187.781-2.495 1.9L4.672 9.641H1.786a.714.714 0 00-.714.715v8.125c0 .395.319.714.714.714h13.422c.205 0 .406-.04.591-.12a2.87 2.87 0 001.628-3.47 2.872 2.872 0 00.462-2.56 2.872 2.872 0 00.582-1.734 3.046 3.046 0 00-.125-.828zM2.68 17.589v-6.34h1.808v6.34H2.679zm14.205-7.88l-.489.424.31.567a1.274 1.274 0 01-.284 1.57l-.488.424.31.567a1.275 1.275 0 01-.283 1.57l-.489.423.31.567a1.269 1.269 0 01-.596 1.766h-9.27v-6.409l2.221-8.047a.984.984 0 01.942-.72.793.793 0 01.797.83l-.214 4.428h7.018c.397.243.643.654.643 1.08 0 .369-.16.717-.438.96z","opacity":".8"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"icon-embed-btn-thumb-up_svg__thumb0_linear","x1":"3.289","y1":"-1.076","x2":"20.543","y2":"3.119","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#896CD9"}}),_c('stop',{attrs:{"offset":".208","stop-color":"#0095E9"}}),_c('stop',{attrs:{"offset":".402","stop-color":"#39AE61"}}),_c('stop',{attrs:{"offset":".618","stop-color":"#FAC714"}}),_c('stop',{attrs:{"offset":".841","stop-color":"#FF8743"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#F4354C"}})]),_c('linearGradient',{attrs:{"id":"icon-embed-btn-thumb-up_svg__thumb1_linear","x1":"10","y1":".801","x2":"10","y2":"13.189","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff","stop-opacity":"0"}})])])])
          )
        }
      }
    